// inspired by d3-scale's linearScale
export const linearScale = (opts = {
  domain: [0, 100],
  range: [0, 1],
  clamp: false,
}) => (
  (value) => {
    let result = (
      opts.range[0] +
      (opts.range[1] - opts.range[0]) *
      ((value - opts.domain[0]) /
      (opts.domain[1] - opts.domain[0]))
    )

    if (opts.clamp) {
      const clamps = [...opts.range].sort((a, b) => a - b)

      result = Math.max(Math.min(clamps[1], result), clamps[0])
    }

    return result
  }
);



// WEBPACK FOOTER //
// ./app/javascript/lib/math.js